module.exports = fox._r("images/reg_left.png", __webpack_public_path__ + "images/reg_left.png");


//////////////////
// WEBPACK FOOTER
// ./images/reg_left.png
// module id = 521
// module chunks = 2